import moment from "moment";
import { Events } from "../interfaces"; // Ajustar según sea necesario
import { capitalizeString } from "../shared/util";

export class EventsAdapter {
  value: any;

  constructor(input: any) {
    this.value = input;
  }

  // Formatear la fecha del evento
  get date() {
    return moment(this.value.visibility_start_date).format("MMMM D");
  }

  // Obtener la hora de inicio
  get startTime() {
    return moment(this.value.visibility_start_date).format("YYYY-MM-DD h:mm a");
  }

  // Obtener la hora de fin
  get endTime() {
    return moment(this.value.visibility_end_date).format("YYYY-MM-DD h:mm a");
  }

  // Obtener el título capitalizado
  get title() {
    return capitalizeString(this.value.name);
  }

  // Obtener el nombre del organizador
  get organizer() {
    return this.value.organizer_fullname || "Unknown Organizer";
  }

  // Obtener la ubicación
  get location() {
    return this.value.location || "No location provided";
  }

  // Obtener la descripción formateada
  get description() {
    return (
      this.value.description ||
      `${this.location} hosts ${this.title}, an event by ${this.organizer}!`
    );
  }

  // Obtener la imagen (banner)
  get image() {
    return this.value.banner
      ? `${process.env.REACT_APP_API_ASSETS}${this.value.banner.id}`
      : "https://placehold.co/400x400";
  }

  adapt(): Events {
    return {
      location: this.value.location || "N/A",
      user_updated: this.value.user_updated,
      user_created: this.value.user_updated,
      created_at: this.value.date_created,
      updated_at: this.value.date_updated,
      visibility_end_date: this.endTime,
      visibility_start_date: this.startTime,
      description: this.description,
      url: this.value.url,
      banner: this.image,
      type: this.value.type,
      organizer_fullname: this.organizer,
      name: this.value.name,
      status: this.value.status,
      id: this.value.id,
    };
  }
}
